import { render } from "./Transfers.vue?vue&type=template&id=088d85cc&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"

import "./Transfers.vue?vue&type=style&index=0&id=088d85cc&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088d85cc"]])

export default __exports__